/**
 * Each list covers all five assignment tables, because a projection keeps only
 * the keys a row has.
 *
 * `isNegation` and `runId` are in both Get and List. A correction is a new row,
 * not an edit, so without them a negation would look the same as the assignment
 * it negates.
 */
const sharedAttributes = [
  'id',
  'questionId',
  'runId',
  'source',
  'isNegation',
  'confidence',
  'assignedBy',
  'createdAt',
] as const;

const valueAttributes = [
  'topicId',
  'questionTypeId',
  'directiveVerbId',
  'scaleId',
  'value',
  'relatedQuestionId',
  'relationshipTypeId',
] as const;

const getAttributes = [...sharedAttributes, ...valueAttributes] as const;

const listAttributes = [
  'id',
  'questionId',
  'runId',
  'source',
  'isNegation',
  'confidence',
  'createdAt',
  ...valueAttributes,
] as const;

export const QuestionEnrichmentAttributes = {
  Get: getAttributes,
  List: listAttributes,
};
